import React, { useContext, useMemo } from "react";
import {
  _t,
  getSystemSettings,
  formatPrice,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { useGeneralHooks } from "../../../../../hooks/generalHooks";
import "./stock.css"

const IngredientStockPrint = ({
  name,
  newConsumption,
  newRow,
  print,
}) => {
  const { t } = useTranslation();
  const {
    //common
    generalSettings,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  const { isIssuanceAmountView } = useGeneralHooks();

  const showAmountView = isIssuanceAmountView && name.includes("Issuance");

  const totals = useMemo(() => {
    if (!showAmountView || !newRow) return { saleRate: 0, amount: 0 };
    return newRow.reduce((acc, item) => {
      const rate = parseFloat(item?.sell_price || item?.sale_price || 0);
      const qty = parseFloat(item?.qty || 0);
      return {
        saleRate: acc.saleRate + rate,
        amount: acc.amount + (rate * qty)
      };
    }, { saleRate: 0, amount: 0 });
  }, [newRow, showAmountView]);

  return (    
    <>
      {/* print */}
      <div className="d-none">
        <div ref={print}>
          {newConsumption && (
            <div className="fk-print">
              <div className="">
                <div className="row">
                  <div className="col-12">
                      <div className="mx-auto" style={{ width: "90px" }}>
                        <img
                        src={`${getSystemSettings(
                          generalSettings,
                          "type_logo"
                        )}`}
                        style={{ width: "100%" }}
                        />
                      </div>
                      <div className="my-2 xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                        {name}
                      </div>

                      <div className="mt-3 row mx-1 print-text-stock text-capitalize">
                        <div className="col-6 print-text-stock--bold my-1">Document No: {newConsumption.document_identity}</div>
                        <div className="col-6 print-text-stock--bold my-1">Document Date : {newConsumption?.documentDate && newConsumption.documentDate?.toDateString()}</div>
                      </div>
                    
                    
                      <div className="row print-text-stock text-capitalize mx-1">
                        {newConsumption?.branch ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            Branch Name :{" "}
                            {newConsumption.branch?.name}
                          </div>
                          ) : ""
                        }
                        {newConsumption?.ref_id ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            Ref No :{" "}
                            {newConsumption.ref_id}
                          </div>
                          ) : ""
                        }
                        {newConsumption?.fbranch ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            From Branch Name :{" "}
                            {newConsumption.fbranch?.name}
                          </div>
                          ) : ""
                        }
                        {newConsumption?.tbranch ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            To Branch Name :{" "}
                            {newConsumption.tbranch?.name}
                          </div>
                          ) : ""
                        }
                        {newConsumption?.fdept || newConsumption?.from_department || newConsumption?.from_dept_name ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            From Dept Name :{" "}
                            {newConsumption.fdept?.name || newConsumption.from_department?.name || newConsumption.from_dept_name}
                          </div>
                          ) : ""
                        }
                        {newConsumption?.tdept || newConsumption?.to_department || newConsumption?.to_dept_name ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            To Dept Name :{" "}
                            {newConsumption.tdept?.name || newConsumption.to_department?.name || newConsumption.to_dept_name}
                          </div>
                          ) : ""
                        }
                        {
                          newConsumption?.issuance_doc_identity && <div className="col-6 print-text-stock--bold my-1">
                            Issue Doc No :{" "}
                            {newConsumption.issuance_doc_identity}
                          </div>
                        }
                        {
                          newConsumption?.requisition_doc_identity && <div className="col-6 print-text-stock--bold my-1">
                            Requisition Doc No :{" "}
                            {newConsumption.requisition_doc_identity}
                          </div>
                        }
                        {authUserInfo.details ? (
                          <div className="col-6 print-text-stock--bold my-1">
                            User Name :{" "}
                            {authUserInfo.details?.name}
                          </div>
                          ) : ""
                        }
                      </div>                 

                      {newConsumption.remarks ? 
                      <div className="row mx-1 my-1 print-text-stock text-capitalize">
                        <div className="print-text-stock--bold">
                          Remarks :{" "}
                          {newConsumption.remarks && newConsumption.remarks}
                        </div>                    
                      </div> : null}

                      {newRow && [
                       newRow.length > 0 && (
                        <div className="my-3">
                          <table className="table table-bordered-sm table-hover ">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border table-Child"
                                  style={{minWidth:"180px"}}
                                >
                                  {_t(t("Name"))}
                                </th>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Unit"))}
                                </th>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Qty"))}
                                </th>
                                {showAmountView && (
                                  <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("Sale Price"))}
                                  </th>
                                )}
                                {showAmountView && (
                                  <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                )}
                                {
                                  newRow[0].hasOwnProperty("item_remarks") && (
                                    <th
                                      scope="col"
                                      className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Remarks"))}
                                    </th>
                                  )
                                }
                              </tr>
                            </thead>

                            <tbody className="align-middle">
                              {newRow?.map((item, index) => {                                
                                return (
                                  <tr className="align-middle" key={index}>
                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                      {item?.item_name}
                                    </td>
                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                      {(item?.unit_name)}
                                    </td> 
                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                      {parseInt(item?.qty)}
                                    </td>  
                                    {showAmountView && (
                                      <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                        {formatPrice(item?.sell_price || item?.sale_price || 0)}
                                      </td>
                                    )}
                                    {showAmountView && (
                                      <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                        {formatPrice((parseFloat(item?.qty || 0) * parseFloat(item?.sell_price || item?.sale_price || 0)) || 0)}
                                      </td>
                                    )}
                                    {
                                      item.hasOwnProperty("item_remarks") && (
                                        <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                    
                                          {item.item_remarks || ""}
                                        </td>
                                      )
                                    }            
                                  </tr>
                                );
                              })}

                              {showAmountView && newRow && newRow.length > 0 && (
                                <tr className="align-middle print-text-stock--bold">
                                  <td colSpan="3" className="print-text-stock text-capitalize border-dark border-1 align-middle text-right pr-2">
                                    {_t(t("Total"))}
                                  </td>
                                  <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                    {formatPrice(totals.saleRate)}
                                  </td>
                                  <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                    {formatPrice(totals.amount)}
                                  </td>
                                  {newRow[0].hasOwnProperty("item_remarks") && (
                                    <td className="border-dark border-1"></td>
                                  )}
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ),
                      ]} 

                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default IngredientStockPrint;
